import React from "react"
import Seo from "../components/Seo"
import styled from "styled-components"
import AvailabilityForm from "../components/ContactPage/AvailabilityForm"
import AvailabilityHero from "../components/ContactPage/AvailabilityHero"
import AvailabilityImg from "../components/ContactPage/AvailabilityImg"
import Layout from "../components/Layout"

const contacto = () => {
  return (
    <Wrapper>
      <Seo title="Reserva" />
      <Layout>
        <AvailabilityHero />
        <div className="section section-center ">
          <div className="form-center">
            <AvailabilityForm />
            <AvailabilityImg />
          </div>
        </div>
      </Layout>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .form-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3.5rem;
    width: 90vw;
    margin: 0 auto;
  }

  @media screen and (min-width: 992px) {
    .form-center {
      justify-content: space-between;
    }
  }

  @media screen and (min-width: 1400px) {
    .form-center {
      max-width: 1200px;
    }
  }
`

export default contacto
